/**
 * Created by Ram on 12/05/2017.
 */
import React, { Component } from 'react';
import Analytics from '../presentation/Analytics';

class AnalyticsWidget extends Component {
    state = {
        testInstanceId: this.props.pageParameters[0],
        testInstance: '',
        triggersCount: 0,
        scenario: '',
        isShowingSummary: true,
        showRemoteConfig: false
    };

    componentDidMount() {
        this.getSingleTestInstance(this.state.testInstanceId);
    }

    toggleShowSummary = () => {
        this.setState(prevState => ({isShowingSummary: !prevState.isShowingSummary}));
    };

    displayRemoteConfigDetails = () => {
        this.setState(prevState => ({showRemoteConfig: !prevState.showRemoteConfig}));
    };

    getSingleTestInstance = testInstanceId => {
        fetch('/service/getSingleTestInstanceDetails?testInstanceId=' + testInstanceId, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        }).then(response => {
            if (response.status === 200) {
                response.json().then(testInstance => {
                    this.setState({ testInstance }, () => {
                        if (this.state.testInstance.mode === 'Battery-only') {
                            this.callBatteryStats(this.state.testInstance._id);
                        }
                    });
                    this.getTriggersCount(testInstance);

                    if(testInstance.scenario) {
                        this.setState({ scenario: testInstance.scenario });
                    } else {
                        this.getScenarioDetails(testInstance);
                    }
                });
            }
        });
    };

    // Find the triggers count
    getTriggersCount = testInstance => {
        let devicesState = Object.values(testInstance.devices);
        let log,
            triggersCount = 0;

        devicesState.map(deviceState => {
            if (deviceState['log']) {
                log = deviceState['log'];
                if (log.triggers) {
                    triggersCount = triggersCount + log.triggers.length;
                }
            }
        });

        this.setState({ triggersCount });
    };

    getScenarioDetails = testInstance => {
        let scenarioId = testInstance.scenarioId;

        if (scenarioId !== null && scenarioId !== '') {
            fetch('/service/getScenarioDetails?scenarioId=' + scenarioId, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(scenario => {
                        this.setState({ scenario });
                    });
                }
            });
        } else {
            this.setState({ scenario: '' });
        }
    };

    callMapAnalytics = id => {
        this.props.navigator.requestMapAnalytics(id);
    };

    callMatrix = id => {
        this.props.navigator.requestMatrixAnalysis(id);
    };

    callBatteryStats = id => {
        this.props.navigator.requestBatteryStats(id);
    };

    render() {
        return (
            <Analytics
                navigator={this.props.navigator}
                loadData={this.state}
                activeAnalytics={this.props.activeAnalytics}
                callMapAnalytics={this.callMapAnalytics}
                callMatrix={this.callMatrix}
                callBatteryStats={this.callBatteryStats}
                toggleShowSummary={this.toggleShowSummary}
                displayRemoteConfigDetails={this.displayRemoteConfigDetails}
            />
        ); //return
    } //render
} //AnalyticsWidget

export default AnalyticsWidget;
